import { GameConstants } from "../GameConstants";

export class AdTimer {

    private static AD_INTERVAL_MILLISECONDS: number = 60000 * 5;
    private static lastTime: number;

    public static timeForAd(): boolean {

        if (!AdTimer.lastTime) {
            AdTimer.lastTime = Date.now();
            return true;
        }

        var eventStartTime = AdTimer.lastTime;
        var eventEndTime = Date.now();
        var duration = eventEndTime - eventStartTime;

        const timeForAd = duration > AdTimer.AD_INTERVAL_MILLISECONDS;

        if (!timeForAd) {
            AdTimer.printOutTimerData(duration);
        }

        return timeForAd;
    }

    private static printOutTimerData(current: number = 0): void {

        if (GameConstants.DEVELOPMENT) {
            console.log("Not time for ad yet.");
            console.log("Interval: " + AdTimer.AD_INTERVAL_MILLISECONDS + " ms");
            if (current) {
                console.error("Current: " + current + " ms");
            }
        }
    }
}

